<template>
  <v-app-bar app height="72px" elevation="0" color="#ffffff" v-if="status && !post_login_action_required" clipped-left class="half-1px-line-btm">
    <v-row no-gutters align="center" class="pl-1">
      <v-app-bar-nav-icon @click.stop="$store.commit('SET_NAV_STATUS', !drawer.status)"></v-app-bar-nav-icon>
      <div class="project-title pl-3">CVHub</div>
      <v-spacer />
    </v-row>
  </v-app-bar>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AppBar',
  computed: {
    ...mapState(['auth', 'drawer']),
    status() {
      return this.auth.status
    },
    post_login_action_required() {
      return this.auth.post_login_action_required
    }
  }
}
</script>
<style scoped></style>
